'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();

import { useRouter } from 'next/navigation';
import { PropsWithChildren, useEffect, useState } from 'react';
import { Container, Button, Alert } from 'reactstrap';
import Loading from '../Loading';
import { useUser } from '../../contexts/UserContext';
import axiosInstance from '../../utils/axios';
import { Dictionaries, Locale } from '../../i18n/i18n-config';
import { getI18nUtils } from '../../i18n/i18n-utils';

type Props = { locale: Locale; dictionary: Partial<Dictionaries> };
// candidate can be set from localstorage, therefore this component relies on user and candidate in context
function Protected({ children, dictionary, locale }: PropsWithChildren<Props>): JSX.Element {
  const { formatMessage } = getI18nUtils(dictionary);
  const { loading, user } = useUser();
  const { push } = useRouter();
  const [newMailRequested, setNewMailRequested] = useState<boolean>(false);
  const [submitting, setSubmitting] = useState<boolean>(false);

  useEffect(() => {
    if (loading) return;
    if (!user) push(`/${locale}/auth/login/`);
  }, [user, loading]);

  if (loading || !user) return <Loading />;

  async function requestNewVerificationLink() {
    setSubmitting(true);
    try {
      await axiosInstance.post(`/auth/request-email-verification-mail`, {
        app: process.env.NEXT_PUBLIC_APP,
        language: locale,
      });
      setNewMailRequested(true);
    } catch (error) {
      console.log(error);
    }
    setSubmitting(false);
  }

  if (user && !user.emailVerified) {
    return (
      <Container fluid="lg" className="text-center my-5 py-5">
        <h1 className="my-5 text-initial">{formatMessage({ id: 'mysynergie_registration_thanks' })}</h1>
        <p>{formatMessage({ id: 'mysynergie_registration_tocomplete' })}</p>

        <hr className="my-5" />
        <p className="text-muted">{formatMessage({ id: 'resend-email-verification' })}</p>
        <Button
          className="d-block mx-auto mt-4"
          color="secondary"
          outline
          size="sm"
          onClick={() => requestNewVerificationLink()}
          disabled={submitting}
        >
          {formatMessage({ id: 'resend-link' })}
        </Button>
        {newMailRequested && <Alert color="success">{formatMessage({ id: 'email-verification-sent' })}</Alert>}
      </Container>
    );
  }

  return children as JSX.Element;
}

export default Protected;
